import { Card, Heading, Span } from "@icg360/design-system";

import { EmailIconLink, PhoneIconLink } from "components/common/link";
import { Stack } from "components/common/stack";
import { usePolicyDetail } from "data/ss-data-hooks";
import { formatPhone, isFormattedPhone } from "utils";

export const InsuranceRepresentative = () => {
  const { data } = usePolicyDetail();
  const {
    agencyName,
    agentStreetNumber,
    agentStreetName,
    agentZipCode,
    agentCity,
    agentState,
    agentEmail,
    agentPhone: unFormattedPhone,
  } = data?.userInsuranceRep ?? {};

  const agentPhone = isFormattedPhone(unFormattedPhone)
    ? unFormattedPhone
    : formatPhone(unFormattedPhone || "");

  return (
    <Card>
      <Stack>
        <Heading size="md">Your representative</Heading>
        <div>
          <div>
            <Span bold>{agencyName}</Span>
          </div>
          <div>
            {/* agent possibly missing street address */}
            {agentStreetNumber || agentStreetName ? (
              <div>
                <Span>{`${agentStreetNumber} ${agentStreetName}`}</Span>
              </div>
            ) : null}
            <div>
              <Span>{`${agentCity}, ${agentState} ${agentZipCode}`}</Span>
            </div>
          </div>
        </div>
        <Stack gap="sm">
          <EmailIconLink email={agentEmail || ""} />
          <PhoneIconLink phone={agentPhone || ""} />
        </Stack>
      </Stack>
    </Card>
  );
};
